import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Eye } from "lucide-react";

const card = "bg-white rounded-[16px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100";
const err = (e) => toast.error(apiErr(e.response?.data?.detail));

function Editor({ m, keys, reload }) {
  const [slots, setSlots] = useState(m.slots);
  const [reason, setReason] = useState("");
  const set = (i, key) => setSlots(slots.map((s) => (s.i === i ? { ...s, key: key || null } : s)));
  const save = async () => { await api.put(`/platform/cmi-minutas/${m.id}`, { slots: slots.map(({ i, key }) => ({ i, key })) }); };
  const preview = async () => {
    try { await save(); const r = await api.get(`/platform/cmi-minutas/${m.id}/preview`, { responseType: "blob" }); window.open(URL.createObjectURL(r.data), "_blank"); } catch (e) { err(e); }
  };
  const act = async (what) => {
    try { await save(); await api.post(`/platform/cmi-minutas/${m.id}/${what}`, what === "reject" ? { reason } : {}); toast.success(what === "activate" ? "Minuta ativada" : "Minuta recusada"); reload(); } catch (e) { err(e); }
  };
  return (
    <div className="mt-3 space-y-3" data-testid={`cmi-editor-${m.id}`}>
      <div className="max-h-[420px] overflow-y-auto border border-slate-100 rounded-lg divide-y divide-slate-100">
        {slots.map((s) => (
          <div key={s.i} className="grid md:grid-cols-[1fr_220px] gap-2 p-2 text-xs items-center">
            <span className="text-slate-600"><b>{s.i + 1}.</b> {s.context}</span>
            <select value={s.key || ""} onChange={(e) => set(s.i, e.target.value)} className="h-8 rounded border border-slate-200 px-2" data-testid={`cmi-slot-${m.id}-${s.i}`}>
              <option value="">— deixar em branco —</option>
              {keys.map((k) => <option key={k} value={k}>{k}</option>)}
            </select>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap gap-2 items-center">
        <button onClick={async () => { try { await save(); toast.success("Ligações guardadas"); reload(); } catch (e) { err(e); } }} className="px-3 h-9 rounded-lg text-sm border border-slate-200 hover:bg-slate-50" data-testid={`cmi-save-${m.id}`}>Guardar ligações</button>
        <button onClick={preview} className="inline-flex items-center gap-1.5 px-3 h-9 rounded-lg text-sm border border-slate-200 hover:bg-slate-50" data-testid={`cmi-preview-${m.id}`}><Eye size={14} /> Pré-visualizar</button>
        <button onClick={() => act("activate")} className="px-3 h-9 rounded-lg text-sm font-semibold bg-ec-green text-white hover:bg-ec-greenDark" data-testid={`cmi-activate-${m.id}`}>Ativar</button>
        <input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Motivo (se recusar)" className="h-9 rounded-lg border border-slate-200 px-2 text-sm" data-testid={`cmi-reason-${m.id}`} />
        <button onClick={() => act("reject")} className="px-3 h-9 rounded-lg text-sm text-red-700 hover:bg-red-50" data-testid={`cmi-reject-${m.id}`}>Recusar</button>
      </div>
    </div>
  );
}

export function CmiMinutasAdmin() {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(() => new URLSearchParams(window.location.search).get("minuta"));
  const load = () => api.get("/platform/cmi-minutas").then(({ data }) => setD(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (d && open) { document.querySelector(`[data-testid="cmi-admin-row-${open}"]`)?.scrollIntoView({ behavior: "smooth", block: "center" }); }
  }, [d]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  return (
    <div className={card} data-testid="cmi-minutas-admin">
      <h3 className="font-heading text-lg text-ec-green">Minutas do CMI das agências</h3>
      <p className="text-sm text-slate-500 mb-3">A IA ligou cada linha a um dado. Confirme, pré-visualize com os nomes dos dados e ative.</p>
      {!d.items.length && <p className="text-sm text-slate-400">Nenhuma minuta carregada.</p>}
      {d.items.map((m) => (
        <div key={m.id} className="border-t border-slate-100 py-3">
          <button onClick={() => setOpen(open === m.id ? null : m.id)} className="text-left text-sm flex flex-wrap gap-2 items-center" data-testid={`cmi-admin-row-${m.id}`}>
            <b>{m.name}</b> · {m.agency_name} · <span className="text-xs">{m.status_label}</span> · <span className="text-xs text-slate-500">{m.mapped}/{m.total} ligadas</span>
          </button>
          {open === m.id && <Editor m={m} keys={d.keys} reload={load} />}
        </div>
      ))}
    </div>
  );
}
